import { useSignUpPage } from "./logic";
import { SignUpPageTemplate } from "./template";

export const SignUpPage = (): JSX.Element => {
  const data = useSignUpPage();
  return <SignUpPageTemplate {...data} />;
};
